export async function login(email, password) {
  const formData = new FormData();
  formData.set("username", email);
  formData.set("password", password);
  formData.set("action", "login");
  const response = await fetch("https://api.apfel-hosting.de", {
      method: "POST",
      body: formData,
      credentials: "include",
    });
  const responseJson = await response.json();
  if (response.status === 200) {
    return { success: true, message: null };
  }else {
    return { success: false, message: responseJson.message };
  }
}

export async function getUserData() {
  const formData = new FormData();
  formData.set("action", "user-data");
  const response = await fetch("https://api.apfel-hosting.de", {
      method: "POST",
      body: formData,
      credentials: "include",
    });
  const responseJson = await response.json();
  const responseJsonMessage = responseJson.message;
  if (response.status === 200) {
    return { success: true, role: responseJsonMessage.role, email_verified: responseJsonMessage.email_verified, discord_verified: responseJsonMessage.discord_verified, credits: responseJsonMessage.credits, server_slots: responseJsonMessage.server_slots, server_count: responseJsonMessage.server_count, name: responseJsonMessage.name };
  }else {
    return { success: false, message: responseJsonMessage.message };
  }
}

export async function getServerData() {
  const formData = new FormData();
  formData.set("action", "servers");
  const response = await fetch("https://api.apfel-hosting.de", {
      method: "POST",
      body: formData,
      credentials: "include",
    });
  const responseJson = await response.json();
  const responseJsonMessage = responseJson.message;
  if (response.status === 200) {
    return { success: true, servers: responseJsonMessage.servers };
  }else {
    return { success: false, message: responseJsonMessage.message };
  }
}

export async function getAllServerData() {
  const formData = new FormData();
  formData.set("action", "admin-servers");
  const response = await fetch("https://api.apfel-hosting.de", {
      method: "POST",
      body: formData,
      credentials: "include",
    });
  const responseJson = await response.json();
  const responseJsonMessage = responseJson.message;
  if (response.status === 200) {
    return { success: 200, servers: responseJsonMessage.servers };
  }else if (response.status === 403){
    return { success: 403, message: responseJsonMessage.message };
  }else {
    return { success: 401, message: responseJsonMessage.message };
  }
}

export async function getAllUserData() {
  const formData = new FormData();
  formData.set("action", "admin-users");
  const response = await fetch("https://api.apfel-hosting.de", {
      method: "POST",
      body: formData,
      credentials: "include",
    });
  const responseJson = await response.json();
  const responseJsonMessage = responseJson.message;
  if (response.status === 200) {
    return { success: 200, users: responseJsonMessage.message };
  }else if (response.status === 403){
    return { success: 403, message: responseJsonMessage.message };
  }else {
    return { success: 401, message: responseJsonMessage.message };
  }
}

export async function deleteServer(id) {
  const formData = new FormData();
  formData.set("action", "delete-server");
  formData.set("serverId", id);
  const response = await fetch("https://api.apfel-hosting.de", {
      method: "POST",
      body: formData,
      credentials: "include",
    });
  const responseJson = await response.json();
  const responseJsonMessage = responseJson.message;
  return { code: response.status }
}